import { t } from "i18next";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import React from "react";

export type PanelProps = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  children?: React.ReactNode;
  title?: string;
  description?: string;
  onHide?: () => void;
  onSave?: () => void;
  actions?: React.ReactNode;
  icons?: React.ReactNode;
  loading?: boolean;
};

export default function Panel(props: PanelProps) {
  const hidePanel = () => {
    props.setVisible(false);
    props.onHide && props.onHide();
  };

  return (
    <Sidebar
      visible={props.visible}
      position="right"
      onHide={hidePanel}
      dismissable={false}
      icons={props.icons ?? undefined}
    >
      {props.loading && (
        <div
          className="w-full flex justify-content-center align-items-center absolute"
          style={{
            background: "rgba(0, 0, 0, 0.7)",
            zIndex: 1000,
            left: 0,
            top: "-77px",
            height: "calc(100vh + 77px)",
          }}
        >
          <div className="pi pi-spinner loader"></div>
        </div>
      )}

      <div className="flex flex-column h-full">
        <div className="flex flex-column mb-4 gap-2">
          {props.title && (
            <span className="font-semibold text-xl">{props.title}</span>
          )}
          {props.description && (
            <span className="text-color-secondary font-medium">
              {props.description}
            </span>
          )}
        </div>

        <div className="flex-grow-1 overflow-auto">{props.children}</div>

        <div>
          {props.actions === undefined && (
            <div className="flex gap-2 mt-3 w-full">
              <Button
                onClick={hidePanel}
                label={t("common.cancel")}
                outlined
                severity="secondary"
                className="w-6"
              />
              <Button
                onClick={() => props.onSave && props.onSave()}
                label={t("common.save")}
                className="w-6"
                severity="success"
              />
            </div>
          )}
          {props.actions && (
            <div className="flex gap-2 mt-3">{props.actions}</div>
          )}
        </div>
      </div>
    </Sidebar>
  );
}
